import { useEffect, useState } from 'react';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import {
	DiscoverSwipeHintChevrons,
	DiscoverSwipeHintLabel,
	DiscoverSwipeHintRoot,
} from './discoverSwipeHint.styles';

const HINT_DURATION_MS = 3000;

const DiscoverSwipeHint = ({ scrollRef, visible, onDismiss }) => {
	const t = useLanguageData('discover');
	const [show, setShow] = useState(false);
	const [fadeOut, setFadeOut] = useState(false);

	useEffect(() => {
		if (!visible) {
			return undefined;
		}

		setShow(true);
		setFadeOut(false);

		const fadeTimer = setTimeout(() => setFadeOut(true), HINT_DURATION_MS - 400);
		const hideTimer = setTimeout(() => {
			setShow(false);
			onDismiss?.();
		}, HINT_DURATION_MS);

		return () => {
			clearTimeout(fadeTimer);
			clearTimeout(hideTimer);
		};
	}, [visible, onDismiss]);

	useEffect(() => {
		const scroll = scrollRef.current;

		if (!scroll || !show) {
			return undefined;
		}

		const dismiss = () => {
			setFadeOut(true);
			setTimeout(() => {
				setShow(false);
				onDismiss?.();
			}, 360);
		};

		scroll.addEventListener('scroll', dismiss, { passive: true });
		scroll.addEventListener('touchstart', dismiss, { passive: true });

		return () => {
			scroll.removeEventListener('scroll', dismiss);
			scroll.removeEventListener('touchstart', dismiss);
		};
	}, [onDismiss, scrollRef, show]);

	if (!show) {
		return null;
	}

	return (
		<DiscoverSwipeHintRoot $fadeOut={fadeOut} role="status" aria-live="polite">
			<DiscoverSwipeHintChevrons aria-hidden="true">
				<svg viewBox="0 0 24 32" fill="none">
					<path
						className="chevron chevron-1"
						d="M5 24L12 17L19 24"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						className="chevron chevron-2"
						d="M5 16L12 9L19 16"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						className="chevron chevron-3"
						d="M5 8L12 1L19 8"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</DiscoverSwipeHintChevrons>
			<DiscoverSwipeHintLabel>{t.swipeHint}</DiscoverSwipeHintLabel>
		</DiscoverSwipeHintRoot>
	);
};

export default DiscoverSwipeHint;
